$mol_frame $mol_embed_native
	attr *
		tabindex <= tabindex
		allow <= allow \
		src <= uri
		srcdoc <= html null
	fullscreen true
	accelerometer true
	autoplay true
	encription true
	gyroscope true
	pip true
	clipboard_read true
	clipboard_write true
